import { RootState } from "../../../redux-store";

export const selectSettingsLoaded = (state: RootState) =>
  state.app.webBookerSettings.loaded;

export const selectLanguage = (state: RootState) =>
  state.app.webBookerSettings.language;
